module.exports = __webpack_public_path__ + "media/98.3f83008a.mp3";